'use strict';

import configOptionsActionCreators from 'actions/ConfigOptionsActionCreators';
import configOptionsStore from 'stores/ConfigOptionsStore';
import personStore from 'stores/PersonStore';
import utils from 'services/utils';

// Payroll configuration options are resolved server-side from a person's payroll (pen test 2026-53 V2: the payroll API
// key is no longer sent to the browser). People on the same payroll share one cached option set, keyed by the opaque,
// server-computed PayrollRef; anyone else is keyed by person id.
export default class ConfigOptionsManager {
    constructor() {
        this.loggedInUser = null;
    }

    static optionsKeyFor(person) {
        if (!person) {
            return 'default';
        }
        return person.PayrollRef ? 'payroll:' + person.PayrollRef : 'person:' + person.Id;
    }

    static apiKeyOptionsKey(apiKey) {
        return 'apikey:' + apiKey;
    }

    setLoggedInUser(person) {
        this.loggedInUser = person;
    }

    // person defaults to the logged-in user.
    getCachedOptions(person) {
        return configOptionsStore.getOptions(ConfigOptionsManager.optionsKeyFor(this.optionsPersonFor(person)));
    }

    getOptions(person) {
        const target = this.optionsPersonFor(person);
        configOptionsActionCreators.getOptions(target ? target.Id : null, ConfigOptionsManager.optionsKeyFor(target));
    }

    getOption(option, person) {
        return utils.pickDeep(this.getCachedOptions(person), 'options.' + option);
    }

    // Admin WebApiConfiguration screens only: they manage payroll connections by API key.
    getCachedOptionsForApiKey(apiKey) {
        return configOptionsStore.getOptions(ConfigOptionsManager.apiKeyOptionsKey(apiKey));
    }

    getOptionsForApiKey(apiKey) {
        configOptionsActionCreators.getOptionsForApiKey(apiKey, ConfigOptionsManager.apiKeyOptionsKey(apiKey));
    }

    getOptionForApiKey(option, apiKey) {
        return utils.pickDeep(this.getCachedOptionsForApiKey(apiKey), 'options.' + option);
    }

    // Whose option set applies. Only the profile and the full business card (self, manager, administrator) say whether
    // the person is payroll linked; anything else (the reduced card of a colleague, list rows) carries no payroll and
    // the caller may not load that person's options (403), so the logged-in user's options apply, as before.
    optionsPersonFor(person) {
        if (person && person.IsPayrollLinked !== undefined) {
            return person;
        }
        return this.getLoggedInPerson();
    }

    getLoggedInPerson() {
        if (!this.loggedInUser) {
            this.loggedInUser = personStore.getLoggedInPersonData() || null;
        }
        return this.loggedInUser;
    }
}
